import io from 'socket.io-client';

// Khởi tạo socket một lần
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
const socket = io(SOCKET_URL, {
    autoConnect: false, // Không kết nối ngay khi khởi tạo
    reconnection: true, // Tự động kết nối lại
    reconnectionDelay: 1000, // Delay 1s trước khi thử kết nối lại
    reconnectionAttempts: 5, // Thử kết nối lại tối đa 5 lần
    timeout: 20000, // Timeout 20s
});

// Event listeners để debug
socket.on('connect', () => {
    console.log('🔌 Socket connected:', socket.id);
});

socket.on('disconnect', (reason) => {
    console.log('🔌 Socket disconnected:', reason);
});

socket.on('connect_error', (error) => {
    console.error('🔌 Socket connection error:', error);
});

socket.on('reconnect', (attemptNumber) => {
    console.log('🔌 Socket reconnected after', attemptNumber, 'attempts');
});

socket.on('reconnect_error', (error) => {
    console.error('🔌 Socket reconnection error:', error);
});

// Helper functions để quản lý socket
export const socketManager = {
    // Kết nối socket
    connect: () => {
        if (!socket.connected) {
            socket.connect();
            console.log('🔌 Attempting to connect socket...');
        }
    },

    // Ngắt kết nối socket
    disconnect: () => {
        if (socket.connected) {
            socket.disconnect();
            console.log('🔌 Socket disconnected manually');
        }
    },

    // Kiểm tra trạng thái kết nối
    isConnected: () => {
        return socket.connected;
    },

    // Emit event với data
    emit: (event, data) => {
        if (socket.connected) {
            socket.emit(event, data);
            console.log('🔌 Emitted event:', event, data);
        } else {
            console.warn('🔌 Socket not connected, cannot emit:', event);
        }
    },

    // Listen event
    on: (event, callback) => {
        socket.on(event, callback);
        console.log('🔌 Listening to event:', event);
    },

    // Remove listener
    off: (event, callback) => {
        socket.off(event, callback);
        console.log('🔌 Removed listener for event:', event);
    },

    // Join room
    joinRoom: (roomId) => {
        if (socket.connected) {
            socket.emit('join_room', roomId);
            console.log('🔌 Joined room:', roomId);
        }
    },

    // Leave room
    leaveRoom: (roomId) => {
        if (socket.connected) {
            socket.emit('leave_room', roomId);
            console.log('🔌 Left room:', roomId);
        }
    }
};

export default socket;
